import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Chatbox from "../layout/common/Chatbox";
import Footer from "../layout/common/Footer";
import Header from "../layout/common/Header";
import NavHeader from "../layout/common/NavHeader";
import SidebarTest from "../layout/common/SidebarTest";
import AddUser from "../layout/user/AddUser";

const NewUser = () => {
  const [showChtBox, setShowChtBox] = useState(false);
  const chtBoxHandler = (e) => {
    setShowChtBox(!e);
  };
  const chatboxClose = (e) => {
    setShowChtBox(!e);
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>New User</title>
      </Helmet>
      <NavHeader />
      <Header onClick={chtBoxHandler} showChtBox={showChtBox} />
      <Chatbox showChtBox={showChtBox} chatboxClose={chatboxClose} />
      <SidebarTest />
      <AddUser />
      <Footer />
    </React.Fragment>
  );
};
export default NewUser;
